//main
import ContentFormatXW from "../content/webc/content-format-xw";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import WebbDividerMedium from "../content/webb/webb-divider-md";
import HeaderSectionDark from "../content/webb/head-section-dark";

import EventsViewWWModule from "../content/events/events-view-ww";


export default function EventsViewWW() {

  return (
  <>
    <ContentFormatXW 
      head='Events'
      link={`/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall/>
          <EventsViewWWModule />

        </>
      } 
    />
  </>
  )
}